var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContentPaste(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "content_paste"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_226_2166",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 19,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 0.555176,
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_226_2166)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "content_paste_2",
    d: "M4.30518 15.752C3.89268 15.752 3.53955 15.6051 3.2458 15.3113C2.95205 15.0176 2.80518 14.6645 2.80518 14.252V3.75195C2.80518 3.33945 2.95205 2.98633 3.2458 2.69258C3.53955 2.39883 3.89268 2.25195 4.30518 2.25195H7.43643C7.57393 1.81445 7.84268 1.45508 8.24268 1.17383C8.64268 0.892578 9.08018 0.751953 9.55518 0.751953C10.0552 0.751953 10.5021 0.892578 10.8958 1.17383C11.2896 1.45508 11.5552 1.81445 11.6927 2.25195H14.8052C15.2177 2.25195 15.5708 2.39883 15.8646 2.69258C16.1583 2.98633 16.3052 3.33945 16.3052 3.75195V14.252C16.3052 14.6645 16.1583 15.0176 15.8646 15.3113C15.5708 15.6051 15.2177 15.752 14.8052 15.752H4.30518ZM4.30518 14.252H14.8052V3.75195H13.3052V6.00195H5.80518V3.75195H4.30518V14.252ZM9.55518 3.75195C9.76768 3.75195 9.9458 3.68008 10.0896 3.53633C10.2333 3.39258 10.3052 3.21445 10.3052 3.00195C10.3052 2.78945 10.2333 2.61133 10.0896 2.46758C9.9458 2.32383 9.76768 2.25195 9.55518 2.25195C9.34268 2.25195 9.16455 2.32383 9.0208 2.46758C8.87705 2.61133 8.80518 2.78945 8.80518 3.00195C8.80518 3.21445 8.87705 3.39258 9.0208 3.53633C9.16455 3.68008 9.34268 3.75195 9.55518 3.75195Z",
    fill: "#C5C5D1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentPaste);
export default __webpack_public_path__ + "static/media/content_paste.1e925dbc38f8a695af89669176686c7b.svg";
export { ForwardRef as ReactComponent };